export const environment = {
  production: true,
  environment: '##{environment}##',
  instrumentationKey: '##{appinsightskey}##',
  mdpUrl: '##{mdpUrl}##',
  graphUrl: '##{graphUrl}##',
  protectedResourceMap: [
    {
      name: 'loganalytics',
      url: 'https://api.loganalytics.io',
      scopes: ['https://api.loganalytics.io/.default'],
    },
    {
      name: 'management',
      url: 'https://management.azure.com',
      scopes: ['https://management.azure.com/.default'],
    },
    {
      name: 'graph',
      url: 'https://graph.microsoft.com/v1.0/me',
      scopes: ['user.read'],
    },
    {
      name: 'ADO1',
      url: 'https://dev.azure.com',
      scopes: ['499b84ac-1321-427f-aa17-267ca6975798/user_impersonation'],
    },
    {
      name: 'ADO2',
      url: 'https://vsrm.dev.azure.com',
      scopes: ['499b84ac-1321-427f-aa17-267ca6975798/user_impersonation'],
    },
    {
      name: 'ADO3',
      url: 'https://app.vssps.visualstudio.com',
      scopes: ['499b84ac-1321-427f-aa17-267ca6975798/user_impersonation'],
    },
    {
      name: 'ADO4',
      url: 'https://adesacentral.visualstudio.com/',
      scopes: ['499b84ac-1321-427f-aa17-267ca6975798/user_impersonation'],
    },
    {
      name: 'jcjit_api',
      url: '##{jcjit_api}##',
      scopes: ['api://d9c435fd-f3a4-4a97-94b6-cef317e5963b/access_as_user'],
    },
    {
      name: 'oncall_api',
      url: '##{oncall_api}##',
      scopes: ['api://e573bf48-fa08-4a4b-9907-f3407083f5c9/access_as_user'],
    },
  ],
  baseUrl: '##{base_url}##',
  auth: {
    clientId: 'c25587f2-2110-46cb-b1a0-3fe9972eebb9',
    authority:
      'https://login.microsoftonline.com/ce904125-3810-44f7-993e-6bbf6e37c0dd',
    redirectUri: '/',
    postLogoutRedirectUri: '/',
  },
  rcjitapi: {
    revokeUri: '##{jcjit_api}##api/1.0/ReleaseDefinition/revoke?org={org}',
    grantUri: '##{jcjit_api}##api/1.0/ReleaseDefinition/grant?org={org}',
    getOrgs: '##{jcjit_api}##api/1.0/ReleaseDefinition/orgs',
    validateUri: '##{jcjit_api}##api/1.0/ReleaseDefinition/validate?org={org}',
    getReleaseChangesUri:
      '##{jcjit_api}##api/1.0/ReleaseDefinition/changes?org={org}&project={project}&rcId={rcId}',
  },
  portalapi: {
    serviceBusesUri: '##{jcjit_api}##api/1.0/ServiceBus/serviceBuses',
    serviceBusQueuesUri: '##{jcjit_api}##api/1.0/ServiceBus/queues',
    peekDeadLetterUri: '##{jcjit_api}##api/1.0/ServiceBus/peekdeadletter',
    processMessagesUri:
      '##{jcjit_api}##api/1.0/ServiceBus/processDeadLetterMessage',
    processAllMessagesUri:
      '##{jcjit_api}##api/1.0/ServiceBus/processAllMessages',
    membershipUri: '##{jcjit_api}##api/1.0/membership',
    ownershipUri: '##{jcjit_api}##api/1.0/ownership',
    pullRequestsUri: '##{jcjit_api}##api/1.0/pullrequests',
    userSettingsUri: '##{jcjit_api}##api/1.0/UserSettings',
    startClassicToYamlMigrationUri: '##{jcjit_api}##api/1.0/YamlConverter/StartClassicToYamlMigration',
    getClassicToYamlMigrationStatusUri: '##{jcjit_api}##api/1.0/YamlConverter/GetMigrationStatus',
    getClassicToYamlMigrationResultsUri: '##{jcjit_api}##api/1.0/YamlConverter/GetYmlFromBlobStorage',
    refineClassicToYamlMigrationUri: '##{jcjit_api}##api/1.0/YamlConverter/RefineClassicToYamlMigration',
    createPullRequestUri: '##{jcjit_api}##api/1.0/YamlConverter/CreateMigrationPullRequest',
    githubTokenUri: '##{jcjit_api}##api/1.0/auth/github/token',
    deleteBranchUri: '##{jcjit_api}##api/1.0/branches/delete'
  },
  oncallapi: {
    teamsUri: '##{oncall_api}##api/1.0/Team',
    teamMemberDetailsUri: '##{oncall_api}##api/1.0/TeamMemberDetails',
    workflowUri: '##{oncall_api}##api/1.0/Workflow',
    alertUri: '##{oncall_api}##api/1.0/Alert',
    alertNotificationUri: '##{oncall_api}##api/1.0/AlertNotification',
  },
  announcementsapi: {
    announcementsUri:
      '##{announcements_api}##api/1.0/Announcement/announcements',
    subscribeUri:
      '##{announcements_api}##api/1.0/Announcement/announcements/subscribe',
    subscriptionsUri:
      '##{announcements_api}##api/1.0/Announcement/announcements/subscriptions',
  },
  slackConfig: {
    slackTeam: '##{slack_team}##',
    slackChannel: '##{slack_channel}##',
    slackWebhook: '##{slack_webhook}##',
  },
  defaultOrg: '##{default_org}##',
  defaultProject: '##{default_project}##',
  featureToggles: {
    peekDeadLetterEnabled: '##{dead_letter_peek_enabled}##',
    releaseReportEnabled: '##{release_report_enabled}##',
    releaseNotesEnabled: '##{release_notes_enabled}##',
    onCallEnabled: '##{on_call_enabled}##',
    releasesEnabled: '##{releases_enabled}##',
    announcementsEnabled: '##{announcement_enabled}##',
  },
  releaseReportConfig: {
    baseUrl: '##{release_report_base_url}##',
  },
  logAnalyticsConfig: {
    subscriptionId: 'eaa40960-9311-4adf-ae36-4ad311cf619c',
    workspaceId:
      '/subscriptions/eaa40960-9311-4adf-ae36-4ad311cf619c/resourcegroups/adesa-subscription-prod/providers/microsoft.operationalinsights/workspaces/adesaprod',
    apiVersion: '2021-12-01-preview',
    cachePrefix: 'la_query_',
    cacheDuration: 24 * 60 * 60 * 1000,
    alertsByTeamQuery: `union
                      app("cvn-alert-router-east-prod").customEvents,
                      app("cvn-alert-router-west-prod").customEvents
                  | where customDimensions.IsProd == "True"
                  | project
                      alertName=tostring(customDimensions.AlertName),
                      teamName=tostring(customDimensions.Team)
                  | summarize count() by teamName, alertName`,
    alertsBreakdownByTeamQuery: `union
                      app("cvn-alert-router-east-prod").customEvents,
                      app("cvn-alert-router-west-prod").customEvents
                  | where customDimensions.IsProd == "True"
                  | project
                      alertName=tostring(customDimensions.AlertName),
                      teamName=tostring(customDimensions.Team),
                      severity=tostring(customDimensions.Severity),
                      resourceGroup=tostring(customDimensions.ResourceGroup)
                | summarize count() by teamName, alertName, resourceGroup, severity`
  },
  github: {
    clientId: '##{GitHub:ClientId}##',
    serviceConnectionId: '##{GitHub:ServiceConnectionId}##',
    org: '##{GitHub:Org}##'
  },
};
